<template>
  <div class="paging">
    <ul v-if="pageTotal > 0" class="paginglist clearfix">
      <li class="paging-start" @click="gofirst">首页</li>
      <li class="paging-txt" :class="{noac:pageNum === 1}" @click="goprev">上一页</li>
      <li :class="{active:item.val === pageNum}" @click="pageChange(item.val)" v-for="item in pageList">
        {{item.txt}}
      </li>
      <li class="paging-txt" :class="{noac:pageNum === pageAll}" @click="gonext">下一页</li>
      <li class="paging-end" @click="goend">末页</li>
    </ul>
    <div class="nopage" v-else>
      <div class="nopage-img">
        <img src="../assets/images/norecord.png" alt=""/>
      </div>
      <p class="nopage-txt">暂无记录</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      pageSize: {
        type: Number,
        default: 10
      },
      pageShowNum: {
        type: Number,
        default: 5
      },
      pageTotal: Number,
      pageNum: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        cur: 1
      }
    },
    computed: {
      // 获取分页总共页数
      pageAll() {
        if (typeof this.pageTotal == 'number') {
          return Math.ceil(this.pageTotal / this.pageSize);
        }
        return 0;
      },
      pagecur: {
        get() {
          return this.pageNum;
        },
        set() {
          // return this.pageNum;
        }
      },
      // 根据页数创建页码
      pageList() {
        const len = this.pageAll;
        const curcenter = Math.floor(this.cur - 3);
        const cur = this.cur;
        const pageNum = this.pageNum;
        const tmp = [];
        let list = [];
        if (len <= 5) {
          for (let i = 1; i <= len; i++) {
            tmp.push(i);
          }
          list = tmp.map(item => {
            return {
              val: item,
              txt: item
            };
          });
        } else {
          if (pageNum > 3) {
            let kpageNum = pageNum - 2;
            if (kpageNum < len - 5) {
              for (let i = kpageNum; i < kpageNum + 5; i++) {
                tmp.push(i);
              }
              tmp.push('...');
              tmp.push(len);
              list = tmp.map(item => {
                return {
                  val: typeof (item) == 'string' ? '...' : item,
                  txt: typeof (item) == 'string' ? '...' : item
                };
              });
            } else {
              for (let i = len - 4; i <= len; i++) {
                tmp.push(i);
              }
              tmp.unshift('...');
              tmp.unshift(1);
              list = tmp.map(item => {
                return {
                  val: typeof (item) == 'string' ? '...' : item,
                  txt: typeof (item) == 'string' ? '...' : item
                };
              });
            }
          }
          if (pageNum <= 3) {
            for (let i = 1; i <= 5; i++) {
              tmp.push(i);
            }
            tmp.push('...');
            tmp.push(len);
            list = tmp.map(item => {
              return {
                val: typeof (item) == 'string' ? '...' : item,
                txt: typeof (item) == 'string' ? '...' : item
              };
            });
          }
        }
        return list;
      }
    },
    watch: {
      pageNum(newVal) {
        this.cur = newVal;
      }
    },
    methods: {
      goprev() {
        let num = this.pageNum - 1;
        if (num <= 0) {
          return;
        }
        this.pageChange(num);
      },
      gonext() {
        let num = this.pageNum + 1;
        if (num > this.pageAll) {
          return;
        }
        this.pageChange(num);
      },
      gofirst() {
        this.pageChange(1);
      },
      goend() {
        this.pageChange(this.pageAll);
      },
      pageChange(cur) {
        if (cur > 0) {
          this.$emit("currentChange", cur);
        }
      }
    }
  };
</script>

<style scoped lang="less">
  .nopage {
    padding: 100px 0 180px 0;
    color: #666;

    .nopage-txt {
      padding-top: 26px;
    }
  }

  .paginglist {
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// Pageing.vue?54d3de0a